import React from 'react';
import Modal from '@material-ui/core/Modal';
import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';
import Button from '@material-ui/core/Button';
import StoryDetail from './StoryDetail';
import {Tools} from './Tools';
import {Story} from './Inc';
import CancelIcon from '@material-ui/icons/Cancel';
import './Archive.scss';

interface Props {
    isOpen:boolean,
    edit():void,
    close():void,
    archive:Story,
}

const ArchiveDetail = (props:Props)=> {
    //Ajax.setUid(props.uid);
    if( !props.isOpen ){
        return (null);
    }

    return (
        <Modal
            aria-labelledby="simple-modal-title"
            aria-describedby="simple-modal-description"
            open={props.isOpen}
            onClose={props.close}
        >
            <div style={Tools.getModalStyle()} className="panel" id="archives">
                <div className="dialogRoot">
                    <div style={{marginBottom:"1em"}}>
                        <div className="table-title" style={{borderBottom:"1px solid white"}}>
                            {props.archive.title}
                        </div>
                        <StoryDetail story={props.archive} status={true}/>
                    </div>
                    <Tooltip title="編集する"><Button variant="contained" color="secondary" style={{width:"100%"}} onClick={props.edit}>編集する</Button></Tooltip>
                    <IconButton aria-label="close" onClick={props.close} color="primary" style={{position:"absolute",top:"-0.3em",right:"-0.3em"}}>
                        <CancelIcon/>
                    </IconButton>
                </div>
            </div>
        </Modal>
	);
}

export default ArchiveDetail;